import React from 'react';

const WelcomeMessage: React.FC = () => {
  return (
    <div className="basis-full sm:w-full md:basis-3/5 text-terminal-text bg-black/40 border border-terminal-subtle p-8 rounded-lg shadow-[0_0_20px_rgba(0,255,65,0.1)] backdrop-blur-sm">
      <div className="mb-6 flex items-center space-x-2">
        <div className="h-3 w-3 rounded-full bg-red-500/50"></div>
        <div className="h-3 w-3 rounded-full bg-yellow-500/50"></div>
        <div className="h-3 w-3 rounded-full bg-green-500/50"></div>
        <span className="ml-4 text-terminal-subtle font-mono text-xs">armant@gaming-laptop:~</span>
      </div>

      <h1 className="font-mono text-2xl sm:text-3xl md:text-4xl mb-6 tracking-tight">
        <span className="text-terminal-subtle">{">"} </span>
        <span className="text-white">Hi </span>
        <span className="wave inline-block origin-bottom-right">👋</span>
        <span className="text-white">, I'm </span>
        <span className="text-terminal-text font-bold">Armant Touche</span>
        <span className="animate-pulse">_</span>
      </h1>

      <div className="space-y-4 font-mono text-base sm:text-lg text-terminal-accent/90">
        <p className="flex items-start">
          <span className="text-terminal-text mr-3">$</span>
          <span>Backend Software Engineer <span className="text-terminal-subtle font-normal italic">#byTrade</span></span>
        </p>
        <p className="flex items-start">
          <span className="text-terminal-text mr-3">$</span>
          <span>Stack: <span className="text-blue-400">Python</span>, <span className="text-yellow-400">SQL</span>, <span className="text-purple-400">Terraform</span>... <span className="text-terminal-subtle italic text-sm">it_depends.sh</span></span>
        </p>
        <p className="flex items-start text-terminal-text/80">
          <span className="text-terminal-text mr-3">$</span>
          <span>Cloud & DevOps Specialist</span>
        </p>
      </div>

      <div className="mt-8 pt-6 border-t border-terminal-subtle/30 text-terminal-subtle font-mono text-xs flex justify-between items-center">
        <span>System: Online</span>
        <span className="animate-pulse">●</span>
      </div>
    </div>
  );
};

export default WelcomeMessage;

